"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedlinedText = void 0;
var _react = require("react");
var _textChanges = require("@common/utils/redline/text/text-changes");
var _OoxmlContent = _interopRequireDefault(require("./OoxmlContent"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var INHERITED_TYPOGRAPHY = {
  fontFamily: "inherit",
  fontSize: "inherit",
  lineHeight: "inherit",
  letterSpacing: "inherit"
};
var RedlinedText = exports.RedlinedText = function RedlinedText(_ref) {
  var textBefore = _ref.textBefore,
    text = _ref.text,
    author = _ref.author,
    _ref$changeExcerpt = _ref.changeExcerpt,
    changeExcerpt = _ref$changeExcerpt === void 0 ? null : _ref$changeExcerpt;
  var redlinedParagraphXml = (0, _react.useMemo)(function () {
    return _textChanges.TextChanges.redlinedParagraphXml(textBefore, text, author);
  }, [textBefore, text, author]);
  var revisionTitleOfAuthor = (0, _react.useCallback)(function () {
    return author;
  }, [author]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_OoxmlContent.default, {
    ooxml: redlinedParagraphXml,
    style: INHERITED_TYPOGRAPHY,
    getHtmlTitleProp: revisionTitleOfAuthor,
    drawReplacementGaps: true,
    changeExcerpt: changeExcerpt,
    "data-sentry-element": "OoxmlComponent",
    "data-sentry-component": "RedlinedText",
    "data-sentry-source-file": "RedlinedText.tsx"
  });
};